<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      @click="newUser"
      class="elinput"
      v-if="Permission.indexOf(141)!=-1">
      {{$t('lang.usercontrol.Add')}}
    </el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(142)!=-1"></xlsx>
    <!-- <p class="tabletitle"></p> -->
    <el-table
      :data="data"
      height="650"
      size="mini"
      id="out-table"
      row-key="user_id"
      @sort-change="sortChange"
      :header-cell-style="{background:'#e4f1ff'}">
      <el-table-column type="selection" min-width="40" reserve-selection :selectable="checkboxInit"></el-table-column>
      <el-table-column :label="$t('lang.usercontrol.UserGroup')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.username"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search1')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.username">
            {{ scope.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.FILE_REAL_H')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.realname"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search2')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.realname">
            {{ scope.row.realname }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.belonging')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_ctid"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search3')">
          </el-input>
          <span
            v-if="scope.$index!=0&&scope.row.customer"
            class="spanov"
            :title="scope.row.customer.c_name">
            {{ scope.row.customer.c_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.bituser')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_iscustomer"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search4')">
          </el-input>
          <span
            v-if="scope.row.user_iscustomer==0&&scope.$index!=0"
            class="spanov">
            {{$t('lang.usercontrol.usertype1')}}
          </span>
          <span
            v-if="scope.row.user_iscustomer==1&&scope.row.user_ctid!=0&&scope.$index!=0"
            class="spanov">
            {{$t('lang.usercontrol.usertype2')}}
          </span>
          <span
            v-if="scope.row.user_iscustomer==1&&scope.row.user_ctid==0&&scope.$index!=0"
            class="spanov">
            {{$t('lang.usercontrol.usertype3')}}
          </span>
          <span
            v-if="scope.row.user_iscustomer==2&&scope.row.user_ctid==0&&scope.$index!=0"
            class="spanov">
            {{$t('lang.usercontrol.usertype4')}}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.phone')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_tel"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search5')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.user_tel">
            {{ scope.row.user_tel }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.ConfigSetting.Language')"  sortable="custom" align="center" >
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_language"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search5')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.user_language">
            {{ scope.row.user_language }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.email')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_email"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search6')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.user_email">
            {{ scope.row.user_email }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.user_admin')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.roleName"
            size="mini"
            clearable
            v-if="scope.$index==0"
            :placeholder="$t('lang.usercontrol.search7')">
          </el-input>
          <span
            v-if="scope.$index!=0&&scope.row.role"
            class="spanov"
            :title="scope.row.role.roleName">
            {{ scope.row.role.roleName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.recently')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            v-model="seek.user_update"
            size="mini"
            v-if="scope.$index==0"
            clearable
            :placeholder="$t('lang.usercontrol.search8')">
          </el-input>
          <span
            v-if="scope.$index!=0"
            class="spanov"
            :title="scope.row.user_update">
            {{ scope.row.user_update }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.usercontrol.alarmSetting')" align="center">
        <template slot-scope="scope">
          <el-switch
            v-if="scope.$index != 0"
            v-model="scope.row.userAlarm.state"
            @change="(val) => switchChange(val, scope.row, scope.$index)"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('lang.usercontrol.monitorSetting')" align="center">
        <template slot-scope="scope">
          <el-switch
            v-if="scope.$index != 0"
            v-model="scope.row.userMonitor.monState"
            @change="(val) => monitorChange(val, scope.row, scope.$index)"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('lang.usercontrol.Operation')" align="center" width="240">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('lang.usercontrol.detailed')"
            placement="top"
            v-if="Permission.indexOf(143)!=-1">
            <el-button
              type="primary"
              icon="icon-ziliao"
              circle
              v-if="scope.$index!=0"
              @click="usermessageshow(scope.row)">
            </el-button>
          </el-tooltip>
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            @click="editUser(scope.row)"
            v-if="Permission.indexOf(144)!=-1&&scope.$index!=0">
          </el-button>
          <el-button
            type="primary"
            icon="icon-icon-"
            circle
            v-if="Permission.indexOf(145)!=-1&&scope.$index!=0"
            @click="freshpassword(scope.row)">
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="remuser(scope.$index)"
            v-if="Permission.indexOf(146)!=-1&&scope.$index!=0">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
    <map></map>
    <!-- 添加用户 -->
    <add-dailog ref="addDailog" @queryKeyword="queryKeyword"></add-dailog>
    <!-- 编辑用户 -->
    <edit-dialog ref="editDialog" @queryKeyword="queryKeyword"></edit-dialog>
    <!-- 修改密码 -->
    <edit-pwd ref="editPwd" @queryKeyword="queryKeyword"></edit-pwd>
    <!-- 用户详情 -->
    <show-detail ref="showDetail"></show-detail>
  </div>
</template>

<script>
import {
  getUserList,
  deleteUser,
  getFunctionalAuthority,
  queryKeyword,
  setAlarm,
  setMonitor
} from "@/api/usercontrol";
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import map from "@/components/map";
import { getPermission } from "../../../cookie/cookie";
import { PublicComponent } from "../../../mixins/common";
import addDailog from "./components/addDialog"
import editDialog from  "./components/editDialog"
import editPwd from "./components/editPwd"
import showDetail from './components/showDetail'
export default {
  mixins: [PublicComponent],
  name: 'Usercontrol',
  activated() {
    this.Permission = getPermission();
    this.queryKeyword()
  },
  data() {
    return {
      Permission: [],
      data: [],
      alramStatus: false, // 标志是否开启报警设置
      monitorStatus: false, // 标志是否开启云监测
      //添加表格搜索框
      seek: {
        username: "",
        realname: "",
        roleid: "",
        user_iscustomer: "",
        user_tel: "",
        user_email: "",
        roleName: "",
        user_update: "",
        user_ctid: ""
      },
      //表格排序
      sort: {
        username: null, //用户名(0：正序，1：倒序)
        realname: null, //真实姓名
        cname: null, //归属客户
        iscustomer: null, //用户类型
        tel: null, //手机
        email: null, //邮箱
        rolename: null, //用户角色
        logintime: null //最近登录时间
      }
    };
  },
  components: {
    pagination,
    xlsx,
    addDailog,
    editDialog,
    editPwd,
    showDetail
  },
  methods: {
    // 报警设置
    switchChange(val, row, index) {
      let params = {
        uid: row.user_id,
        state: 0
      }
      if(val === true) {
        this.$confirm(this.$t('lang.usercontrol.alarmTips'),this.$t('lang.Button.tips'), {
          cancelButtonText: this.$t('lang.Button.cancel'),
          confirmButtonText: this.$t('lang.Button.submit'),
          type: 'warning',
          center: true
        }).then(res => {
          params.state = 1
          setAlarm(params).then(res => {
            if(res.data.code === 0) {
              this.$message.success(this.$t('lang.Button.successSetting'))
              this.data[index].userAlarm.state = true
            }else{
              this.$message.error(this.$t('lang.Button.failSetting'))
              this.data[index].userAlarm.state = false
            }
          }).catch(() => {
            this.data[index].userAlarm.state = false
          })
        }).catch(() => {
          this.data[index].userAlarm.state = false
        })
      }else{
        this.$confirm(this.$t('lang.usercontrol.alarmCloseTips'), this.$t('lang.Button.tips'), {
          cancelButtonText: this.$t('lang.Button.cancel'),
          confirmButtonText: this.$t('lang.Button.submit'),
          type: 'warning',
          center: true
        }).then(res => {
          params.state = 0
          setAlarm(params).then(res => {
            if(res.data.code === 0) {
              this.$message.success(this.$t('lang.Button.successSetting'))
              this.data[index].userAlarm.state = false
            }else{
              this.$message.error(this.$t('lang.Button.failSetting'))
              this.data[index].userAlarm.state = true
            }
          }).catch(() => {
            this.data[index].userAlarm.state = true
          })
        }).catch(() => {
          this.data[index].userAlarm.state = true
        })
      }  
    },
    // 云监测功能
    monitorChange(val, row, index) {
      let params = {
        uid: row.user_id,
        monState: 0
      }
      if(val === true) {
        this.$confirm(this.$t('lang.usercontrol.monitorTips'),this.$t('lang.Button.tips'), {
          cancelButtonText: this.$t('lang.Button.cancel'),
          confirmButtonText: this.$t('lang.Button.submit'),
          type: 'warning',
          center: true
        }).then(res => {
          params.monState = 1
          setMonitor(params).then(res => {
            if(res.data.code === 0) {
              this.$message.success(this.$t('lang.Button.successSetting'))
            }else{
              this.$message.error(this.$t('lang.Button.failSetting'))
            }
          }).catch(() => {
          }).finally(() => {
            this.queryKeyword()
          })
        }).catch(() => {
          this.data[index].userMonitor.monState = false
        })
      }else{
        this.$confirm(this.$t('lang.usercontrol.monitorCloseTips'), this.$t('lang.Button.tips'), {
          cancelButtonText: this.$t('lang.Button.cancel'),
          confirmButtonText: this.$t('lang.Button.submit'),
          type: 'warning',
          center: true
        }).then(res => {
          params.state = 0
          setMonitor(params).then(res => {
            if(res.data.code === 0) {
              this.$message.success(this.$t('lang.Button.successSetting'))
            }else{
              this.$message.error(this.$t('lang.Button.failSetting'))
            }
          }).catch(() => {
          }).finally(()=> {
            this.queryKeyword()
          })
        }).catch(() => {
          this.data[index].userMonitor.monState = true
        })
      }  
    },
    // 新增用户弹窗
    newUser() {
      this.$refs.addDailog.show()
    },
    // 编辑用户弹窗
    editUser(item) {
      this.$refs.editDialog.show(item)
    },
    //分页组件
    SizeChanges(val) {
      this.limit = val;
      this.queryKeyword();
    },
    CurrentChanges(val) {
      this.offset = val;
      this.queryKeyword();
    },
    //删除用户
    remuser(index) {
      this.$confirm(this.$t('lang.DeleteBox.Tetx'), this.title, {
          confirmButtonText: this.$t('lang.DeleteBox.confirmButtonText'),
          cancelButtonText: this.$t('lang.DeleteBox.cancelButtonText'),
          type: 'warning',
          center: true
        }).then(() => {
           deleteUser(this.data[index].user_id,this.data[index].user_iscustomer,this.data[index].user_ctid).then(res => {
            this.offset = 1
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message6"),
                type: "success"
              });
              this.queryKeyword();
            } else if (res.data.code === 11) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message7"),
                type: "error"
              });
              this.queryKeyword();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message8"),
                type: "warning"
              });
              this.queryKeyword();
            }
          });
        }).catch(() => {
        });
     
    },
    //修改密码
    freshpassword(row) {
      this.$refs.editPwd.show(row.user_id)
    },
    usermessageshow(row) {
      this.$refs.showDetail.show(row)
    },
    //搜索key
    queryKeyword() {
      queryKeyword(
        [
          this.seek.username,
          this.seek.realname,
          this.seek.user_ctid,
          this.seek.user_iscustomer,
          this.seek.user_tel,
          this.seek.user_email,
          this.seek.roleName
        ],
        this.offset,
        this.limit,
        this.sort,
        this.$i18n.locale == "en-US" ? 1 : 0
      ).then(res => {
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.offset = res.data.data.offset;
        this.limit = res.data.data.limit;
        this.data.unshift({});
        this.data.forEach((item, index) => {
          if(index !== 0) {
            if(item.userAlarm) { // 存在userAlarm字段
              item.userAlarm.state = item.userAlarm.state == 0 ? false : true
            }else{ // 不存在userAlarm字段
              let alarm = {
                state: false
              }
              this.$set(item, 'userAlarm', alarm)
            }
            if(item.userMonitor) { // userMonitor
              item.userMonitor.monState = item.userMonitor.monState == 1 ? true : false
            }else{ // userMonitor
              let monitor = {
                monState: false
              }
              this.$set(item, 'userMonitor', monitor)
            }
          }
        })
      });
    },
    //搜索框禁止选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    //表格排序
    sortChange({ column, prop, order }) {
      // 每次点击清空一次排序的赋值
      this.sort = {
        username: null, //用户名(0：正序，1：倒序)
        realname: null, //真实姓名
        cname: null, //归属客户
        iscustomer: null, //用户类型
        tel: null, //手机
        email: null, //邮箱
        rolename: null, //用户角色,
        logintime: null //最近登录
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.usercontrol.UserGroup")) {
        this.sort.username = sortlist;
      } else if (label == this.$t("lang.usercontrol.FILE_REAL_H")) {
        this.sort.realname = sortlist;
      } else if (label == this.$t("lang.usercontrol.belonging")) {
        this.sort.cname = sortlist;
      } else if (label == this.$t("lang.usercontrol.bituser")) {
        this.sort.iscustomer = sortlist;
      } else if (label == this.$t("lang.usercontrol.phone")) {
        this.sort.tel = sortlist;
      } else if (label == this.$t("lang.usercontrol.email")) {
        this.sort.email = sortlist;
      } else if (label == this.$t("lang.usercontrol.user_admin")) {
        this.sort.rolename = sortlist;
      } else if (label == this.$t("lang.usercontrol.recently")) {
        this.sort.logintime = sortlist;
      }
    },
  },
};
</script>

<style scoped>
.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}

</style>
<style>

</style>
